
import { useState, useMemo } from 'react';
import { FormFieldType } from '@/types/form';

export const useElementGroups = (isPage3: boolean, elements: FormFieldType[]) => {
  return useMemo(() => {
    if (!isPage3) return null;
    
    // Separate elements into different groups for Page 3
    const topicElements: FormFieldType[] = [];
    const knowledgeElements: FormFieldType[] = [];
    const skillsElements: FormFieldType[] = [];
    const attitudeElements: FormFieldType[] = [];
    const otherElements: FormFieldType[] = [];
    
    elements.forEach(element => {
      // Topic related fields: worksheet search, topic input, document links
      if (
        element.id === 'section_development_info' || 
        element.id === 'worksheet_search' || 
        element.id === 'topic_learned' ||
        element.id === 'document_links'
      ) {
        topicElements.push(element);
      }
      // Knowledge rating and behavior
      else if (
        element.id === 'knowledge_rating' || 
        element.id === 'knowledge_behavior'
      ) {
        knowledgeElements.push(element);
      }
      // Skills rating and behavior
      else if (
        element.id === 'skills_rating' || 
        element.id === 'skills_behavior'
      ) {
        skillsElements.push(element);
      }
      // Attitude rating and behavior
      else if (
        element.id === 'attitude_rating' || 
        element.id === 'attitude_behavior'
      ) {
        attitudeElements.push(element);
      }
      // All other fields
      else {
        otherElements.push(element);
      }
    });
    
    return {
      topicElements,
      knowledgeElements,
      skillsElements,
      attitudeElements,
      otherElements
    };
  }, [isPage3, elements]);
};
